"use client";

import React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
  useTheme,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const AccountsHeader = ({ month, setMonth, year, setYear }) => {
  const theme = useTheme();

  const handleDateChange = (newValue) => {
    if (!newValue) return;
    setMonth(newValue.format("MMMM"));
    setYear(newValue.year());
  };

  return (
<Paper
  elevation={0}
  sx={{
    borderRadius: 3,
    px: 1,
    // py: { xs: 2, sm: 2.5 },
    mb: { xs: 3, sm: 4, md: 5 },
    bgcolor: theme.palette.background.paper,
    boxShadow: "none", // ensures no shadow at all
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
    justifyContent: "space-between",
    gap: 2,
  }}
>

      {/* Left Section */}
      <Box         sx={{
            my:"10px"
          }}>
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{
            // color: theme.palette.primary.main,
            letterSpacing: "0.5px",
          }}
        >
          Accounts Overview
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mt: 0.5,
          }}
        >
          Reporting Period:{" "}
          <strong style={{ color: theme.palette.text.primary }}>
            {month} {year}
          </strong>{" "}
          • Generated on{" "}
          <strong style={{ color: theme.palette.text.primary }}>
            {dayjs().format("DD MMM YYYY")}
          </strong>
        </Typography>
      </Box>

      {/* Right Section */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "stretch", sm: "center" }}
        spacing={1.5}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={["year", "month"]}
            label="Select Month & Year"
            value={dayjs(`${year}-${month}-01`)}
            onChange={handleDateChange}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  minWidth: { xs: "100%", sm: 220 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    bgcolor:
                      theme.palette.mode === "dark"
                        ? theme.palette.grey[800]
                        : "#f9fafb",
                    border: `1px solid ${theme.palette.divider}`,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused": {
                      borderColor: theme.palette.primary.main,
                      boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
                    },
                  },
                  "& fieldset": { border: "none" },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Stack>
    </Paper>
  );
};

export default AccountsHeader;
